// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--10-2!../../../node_modules/sass-loader/dist/cjs.js??ref--10-3!./game-summary.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("3cb29eec", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/components/GrammarGame/game-summary.scss
// module id = 416
// module chunks = 1 3